import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { TextInput, SlSectionTitle, SlFormEntryRow, SlRadioButton, SlSectionLabel } from '../editors'
import { metadataService } from '../../_services'
import { userService } from '../../_services/user.service';
import { isEqual } from 'lodash';

// Stable identity so TextInput does not see a new array on every render when there is nothing to show.
const NO_ERRORS = [];

class IdentificationType extends Component {
    constructor(props) {
        super(props);

        let propsValue = this.props.value;

        this.state = {
            useSSN: !propsValue.individualTaxIdentificationNumber,
            visited: false,
            formValue: {
                socialSecurityNumber: (propsValue.socialSecurityNumber) ? propsValue.socialSecurityNumber : '',
                individualTaxIdentificationNumber: (propsValue.individualTaxIdentificationNumber) ? propsValue.individualTaxIdentificationNumber : '',
                reEnterIdentificationNumber: (propsValue.reEnterIdentificationNumber) ? propsValue.reEnterIdentificationNumber : '',
            }
        };
        this.handleInput = this.handleInput.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
        this.getValidationErrors = this.getValidationErrors.bind(this);
    }
    componentDidMount() {
        if (this.props.isValid) {
            var validation = this.getValidationErrors(this.state);
            this.props.isValid(this.props.name, validation.isValid);
        }
    }

    componentDidUpdate(prevProps) {
        if (!isEqual(prevProps.value, this.props.value)) {
            if (!this.state.visited && this.props.value.socialSecurityNumber || this.props.value.individualTaxIdentificationNumber) {
                let newState = {
                    ...this.state,
                    visited: true,
                    formValue: {
                        ...this.state.formValue,
                        socialSecurityNumber: (this.props.value.socialSecurityNumber) ? this.props.value.socialSecurityNumber : '',
                        individualTaxIdentificationNumber: (this.props.value.individualTaxIdentificationNumber) ? this.props.value.individualTaxIdentificationNumber : '',
                    },
                };

                this.setState(newState);
            }
        }
    }

    handleOnBlur = ({ target: { name, value } }) => {
        this.setState({ visited: true });
    }

    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        let newState = {
            ...this.state,
            formValue: formValue
        };

        if (name === "useSSN") {
            newState.useSSN = value === "true";
            newState.formValue.reEnterIdentificationNumber = "";
            if (newState.useSSN) {
                newState.formValue.individualTaxIdentificationNumber = "";
            }
            else {
                newState.formValue.socialSecurityNumber = "";
            }
        }

        this.handleChangeState(newState);

        if (this.props.isValid) {
            var validation = this.getValidationErrors(newState);
            this.props.isValid(name, validation.isValid);
        }

        if (newState.useSSN) {
            let returnValue = { SocialSecurityNumber: newState.formValue.socialSecurityNumber, isValid: validation.isValid, useSSN: true };
            this.props.onChange({ target: { name: this.props.name, value: returnValue } });
        }
        else {
            let returnValue = { IndividualTaxIdentificationNumber: newState.formValue.individualTaxIdentificationNumber, isValid: validation.isValid, useSSN: false };
            this.props.onChange({ target: { name: this.props.name, value: returnValue } });
        }
    };

    handleChangeState(newState) {
        this.setState(newState)
    }

    getValidationErrors(checkState) {
        let validation = {
            isValid: true,
            validationError: {}
        };
        if (!checkState.useSSN) {
            if (!checkState.formValue.individualTaxIdentificationNumber) {
                validation.isValid = false;
                validation.validationError = { fieldName: "IndividualTaxIdentificationNumber", messageName: "RequiredFieldNotSupplied" };
            }
            else  {
                let itinError = checkState.formValue.individualTaxIdentificationNumber.length !== 9;
                if (itinError) {
                    validation.isValid = false;
                    validation.validationError = { fieldName: "IndividualTaxIdentificationNumber", messageName: "InvalidITINLength" };
                } else if (this.props.requireReEntry && checkState.formValue.individualTaxIdentificationNumber !== checkState.formValue.reEnterIdentificationNumber) {
                    validation.isValid = false;
                    validation.validationError = { fieldName: "reEnterIdentificationNumber", messageName: "TaxIdentificationDoesNotMatch" };
                }
            }
        }
        else {
            if (!checkState.formValue.socialSecurityNumber) {
                validation.isValid = false;
                validation.validationError = { fieldName: "SocialSecurityNumber", messageName: "RequiredFieldNotSupplied" };
            }
            else {
                let ssnError = !metadataService.ValidSSN(checkState.formValue.socialSecurityNumber);
                if (ssnError) {
                    validation.isValid = false;
                    validation.validationError = { fieldName: "SocialSecurityNumber", messageName: "InvalidSSN" };
                } else if (this.props.requireReEntry && checkState.formValue.socialSecurityNumber !== checkState.formValue.reEnterIdentificationNumber) {
                    validation.isValid = false;
                    validation.validationError = { fieldName: "reEnterIdentificationNumber", messageName: "SocialSecurityDoesNotMatch" };
                }
            }
        }
        return validation;
    }

    render() {
        let fieldErrors = NO_ERRORS;
        if (this.props.isRequired && this.state.visited) {
            fieldErrors = [this.getValidationErrors(this.state).validationError];
        }

        return (
            <div>
                <div>
                    <SlSectionLabel sectionName="SelectYourIdentificationType" />
                    <SlFormEntryRow>
                        <SlRadioButton
                            fieldName='useSSN'
                            onChange={this.handleInput}
                            isSelected={this.state.useSSN}
                            disabled={this.props.readOnly}
                            value={"true"}>
                            {metadataService.getFieldNameLabel('SocialSecurityNumberSSN')}
                        </SlRadioButton>
                        <SlRadioButton
                            fieldName='useSSN'
                            onChange={this.handleInput}
                            disabled={this.props.readOnly}
                            isSelected={!this.state.useSSN}
                            value={"false"}>
                            {metadataService.getFieldNameLabel('IndividualTaxIdentificationNumberITIN')}
                        </SlRadioButton>
                    </SlFormEntryRow>
                    <SlFormEntryRow>
                        {this.state.useSSN && (
                            <TextInput
                                name="SocialSecurityNumber"
                                value={this.state.formValue.socialSecurityNumber}
                                showLabel={this.props.showLabel}
                                isRequired={this.props.isRequired}
                                fieldErrors={fieldErrors}
                                placeholder={"000-00-0000"}
                                type={"number"}
                                disabled={this.props.readOnly}
                                maskOnBlur={true}
                                onChange={this.handleInput}
                                onBlur={this.handleOnBlur}
                                hideNumberSpinner={true}
                                allowLeadingZeroes={true}
                                maxLength={9} />
                        )}
                        {!this.state.useSSN && (
                            <TextInput
                                name="IndividualTaxIdentificationNumber"
                                value={this.state.formValue.individualTaxIdentificationNumber}
                                showLabel={this.props.showLabel}
                                isRequired={this.props.isRequired}
                                fieldErrors={fieldErrors}
                                disabled={this.props.readOnly}
                                onChange={this.handleInput}
                                onBlur={this.handleOnBlur}
                                type={"number"}
                                maskOnBlur={true}
                                hideNumberSpinner={true}
                                maxLength={9} />
                        )}
                    </SlFormEntryRow>
                    {this.props.requireReEntry && (
                        <SlFormEntryRow>
                            <TextInput
                                name="reEnterIdentificationNumber"
                                value={this.state.formValue.reEnterIdentificationNumber}
                                showLabel={this.props.showLabel}
                                customLabel={this.state.useSSN ? "ReEnterSocialSecurityNumber" : "ReEnterIndividualTaxIdentificationNumber" }
                                isRequired={this.props.isRequired}
                                fieldErrors={fieldErrors}
                                placeholder={this.state.useSSN ? "000-00-0000" : ""}
                                type={"number"}
                                disabled={this.props.readOnly}
                                maskOnBlur={true}
                                onChange={this.handleInput}
                                onBlur={this.handleOnBlur}
                                hideNumberSpinner={true}
                                allowLeadingZeroes={true}
                                maxLength={9}
                                />
                        </SlFormEntryRow>
                    )}
                </div>
            </div>
        );
    }
}

//Define prop types
IdentificationType.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isValid: PropTypes.func,
    showLabel: PropTypes.bool,
    value: PropTypes.object,
    fieldErrors: PropTypes.array,
    isRequired: PropTypes.bool,
    readOnly: PropTypes.bool,
    requireReEntry: PropTypes.bool
}
IdentificationType.defaultProps = {
    showLabel: true,
    isRequired: true,
    value: {},
    readOnly: false,
    requireReEntry: false
}

const connectedIdentificationType = connect()(IdentificationType)
export { connectedIdentificationType as IdentificationType }